<div class="tab-content-wrapper mt-4">
  @if (formGroup) {
    <app-entity-additionally-fields [data]="data" [nalogForms]="nalogForms" [(form)]="formGroup" (postDataChange)="postData = $event"></app-entity-additionally-fields>
  }

  <div class="col-12 mt-4">
    <button (click)="saveForm()" type="button" [disabled]="!formGroup.valid" class="button">
      Сохранить
    </button>
  </div>
</div>
